import { render, staticRenderFns } from "./rankLists.vue?vue&type=template&id=46955da8&scoped=true&"
import script from "./rankLists.vue?vue&type=script&lang=js&"
export * from "./rankLists.vue?vue&type=script&lang=js&"
import style0 from "./rankLists.vue?vue&type=style&index=0&id=46955da8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46955da8",
  null
  
)

export default component.exports